import colors from "./generated/colors";
// Workaround for Safari not supporting radius on outline. We keep the border and add a box-shadow inset.
const focusBorder = {
    borderColor: `${colors.semantic.outline.focus} !important`,
    border: "1px solid",
    boxShadow: `inset 0px 0px 0px 2px ${colors.semantic.outline.focus}`,
};
export { focusBorder };
//# sourceMappingURL=misc.js.map